import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ChangeEmailSuccess = () => {
    return (_jsxs("div", { children: [_jsx("div", { className: 'mb-2 font-bold text-info', children: "Your email has been successfully changed." }), _jsx("p", { children: "Please ensure you are running the latest version of Standard Notes on all platforms to ensure maximum compatibility." })] }));
};
export default ChangeEmailSuccess;
